import { createContext, createElement, useContext, useReducer } from 'react';
import type { Mutation } from './mutations';
import type { State } from './types';
import { reducer } from './mutations';

export interface MentionsStore {
  state: State;
  dispatch: React.Dispatch<Mutation>;
}

const initialState: State = {
  list: [],
  loaded: false,
};

export const MentionsContext = createContext<MentionsStore>({
  state: initialState,
} as MentionsStore);

export function MentionsStoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [state, dispatch] = useReducer(reducer, initialState);

  return createElement(
    MentionsContext.Provider,
    { value: { state, dispatch } },
    children,
  );
}

export function useMentionsStore() {
  return useContext(MentionsContext);
}
